import { Component } from "react";
import { connect } from "react-redux";
// import {change_header} from '../../../redux/actions/HeroBarAction'
import {
    set_datapage,
    getMapStateDefault,
  } from "@ora/recursos/src/redux/actions/DataPageAction";
  import { Templates } from "@ora/recursos";
  import {
    checkDataDirectorio,
    // seDataDirectorio,
    seDatatDocumentos,
  } from "@ora/recursos/src/redux/actions/DirectoriosActions";

import { Button, Card, Section, Form } from "react-bulma-components";
import { baseUrl, localUrl } from "@ora/recursos/src/helpers/Url";
import axios from "axios";
import $ from "jquery";
import dt from "datatables.net";
import { Link, Redirect, useHistory } from "react-router-dom";
import { tagActivo } from "helpers/Datatables";
import Swal from "sweetalert2";
import { PageLength } from "helpers/Datatables";
$.DataTable = dt;

class Cientificos extends Component {
  state = {
    listType: [],
    isloadsearch: true,
  };
  filter = {
    buscar: "",
  };
  table = null;
  datatable = null;

  constructor(props) {
    super(props);

    this.props.set_datapage({
      titulo: "Gestión de Cientificos y Academicos",
      isbackend: true,
      breadcrumb: [
        { name: "Intranet", url: "#" },
        { name: "Config", url: "#" },
        { name: "Gestión de Cientificos y Academicos", url: "#", active: true },
      ],
    });
  }
  componentDidMount() {
    this.init();
  }
  onClick_btnNuevoRecurso = () => {
    console.log(
      "asdasdsad",
      this.props.history.push(localUrl("/config/cientifico/create"))
    );
  };
  init = () => {
    const OnCall = () => {
      this.setState({
        isloadsearch: true,
      });
    };
    const OnFinish = () => {
      this.setState({
        isloadsearch: false,
      });
    };

    this.configDT = {
      data: [],
      dom: "<'columns'<'column is-full'<'table-container't>>><'columns'<'column'l><'column'p>>",
      processing: true,
      pageLength: PageLength(),
      ajax: {
        url: baseUrl("cites/cientifico/datatable"),
        data: (d) => {
          console.log("params buscar", this.state.buscar);
          d.filter = this.filter;
          return d;
        },
        beforeSend: function () {
          OnCall(); // show wating animation
        },
        error: function (xhr, error, thrown) {
          OnFinish();
          //alert(xhr.status);
          //alert(thrown);
          Swal.fire({
            title: thrown,
            html: `
                     <p> Se encontró un error en el servidor, intente más tarde.</p>
                     <p>Mensaje: ${xhr.status} - ${error}</p>
                    `,
            icon: "error",
          }).then((sr) => {});
        },
      },
      serverSide: true,
      order: [[0, "asc"]],
      createdRow: (r, d, i) => {},
      columns: [
        { data: "per_int_id" },
        { data: "per_txt_name" },
        { data: "per_txt_last_name" },
        { data: "per_txt_sex" },
        { data: "per_txt_phone" },
        {
          data: "per_sts_registro",
          render: (d, t, r) => {
            return tagActivo(d);
          },
        },
        {
          data: "per_int_id",
          render: (d, t, r) => {
            return `
                    <div class="buttons is-center">
                        <button data-id="${d}" data-accion="ver" class="button is-small is-info btn-acciones" title="Ver">
                            <span class="icon is-small"><i class="fas fa-eye"></i></span>
                        </button=>
                        <button type="button" data-id="${d}" data-accion="editar" class="button is-small is-info btn-acciones" title="Editar">
                            <span class="icon is-small"><i class="fas fa-pen"></i></span>
                        </button>
                        <button type="button" data-id="${d}" data-accion="estado" class="button is-small is-info btn-acciones" title="Estado">
                            <span class="icon is-small"><i class="fas fa-sync"></i></span>
                        </button>
                        <button type="button" data-id="${d}" data-accion="eliminar" class="button is-small is-info btn-acciones" title="Eliminar">
                            <span class="icon is-small"><i class="fas fa-trash"></i></span>
                        </button>
                    </div>
                    `;
          },
        },
      ],
      drawCallback: (dcall) => {
        this.setState({
          total: dcall._iRecordsDisplay,
          isloadsearch: false,
        });
        $("#tblCientificos_paginate a.previous").addClass(
          "pagination-link pagination-previous"
        );
        $("#tblCientificos_paginate a.next").addClass(
          "pagination-link pagination-next"
        );
        $("#tblCientificos_paginate a.next").addClass(
          "pagination-link pagination-next"
        );
        $("#tblCientificos_paginate span a.paginate_button.current").addClass(
          "pagination-link is-current"
        );
        $("#tblCientificos_paginate span a.paginate_button").addClass(
          "pagination-link"
        );
      },
    };
    this.table = $("#tblCientificos");

    this.datatable = this.table
      .DataTable(this.configDT)
      .on("click", ".btn-acciones", this.OnClick_acciones);
  };
  OnClick_acciones = (evt) => {
    //   console.log(this.props)
    let { accion, id } = evt.currentTarget.dataset;
    switch (accion) {
      case "ver":
        this.props.history.push(localUrl("/config/cientifico/" + id));
        break;
      case "editar":
        this.props.history.push(localUrl("/config/cientifico/" + id + "/edit"));
        break;
      case "estado":
        axios
          .put(baseUrl("cites/cientifico/" + id + "?m=estado"))
          .then((res) => {
            if (res.data.success) {
              this.datatable.draw(false);
            }
            Swal.fire("Cientificos", res.data.message, "success").then(
              (sr) => {}
            );
          });
        break;
      case "eliminar":
        axios.delete(baseUrl("cites/cientifico/" + id)).then((res) => {
          if (res.data.success) {
            this.datatable.draw(false);
          }
          Swal.fire("Cientificos", res.data.message, "error").then((sr) => {});
        });
        break;

      default:
        break;
    }
  };

  onSubmit_filter = (evt) => {
    evt.preventDefault();
    console.log(evt);
    this.filter.buscar = evt.target.elements.search.value;
    this.datatable.draw();
  };
  render() {
    return (
        <Templates.Default.BasePageRoute2
        localUrl={localUrl}
        dataPage={this.props.DataPage}
      >
      <div className="is-main-section">
        <Card>
          <Card.Content>
            {/* <Link to={localUrl('/config/recursos/1')}>ssss</Link> */}
            <form action="" onSubmit={this.onSubmit_filter}>
              <div className="field is-horizontal">
                <div className="field-body">
                  <div className="column is-one-third">
                    <div className="field">
                      <div className="control has-icons-left has-icons-right">
                        <input
                          type="text"
                          autoComplete="on"
                          placeholder="Nombre"
                          name="search"
                          className="input form-control"
                        />
                        <span className="icon is-left">
                          <i className="fas fa-search"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="column">
                    <div className="field">
                      <Button
                        className={
                          "is-success " +
                          (this.state.isloadsearch ? "is-loading" : "")
                        }
                      >
                        Buscar
                      </Button>
                    </div>
                  </div>

                  <div className="column has-text-right">
                    <Button
                      type="button"
                      onClick={this.onClick_btnNuevoRecurso}
                      className="is-info"
                    >
                      Nuevo Cientifico
                    </Button>
                  </div>
                </div>
              </div>
            </form>
            <hr />
            <div className="columns">
              <div className="column level">
                <div className="level-right">
                  <div className="level-item">{this.state.total} registros</div>
                </div>
              </div>
            </div>
            <div className="b-table has-pagination">
              <div className="table-wrapper">
                <div>
                  <table
                    id="tblCientificos"
                    className="table is-fullwidth is-bordered is-hoverable is-fullwidth"
                  >
                    <thead>
                      <tr>
                        <th className="is-sortable">#</th>
                        <th>Nombre</th>
                        <th>Apellido</th>
                        <th>Sexo</th>
                        <th>Telefono</th>
                        <th>Estado</th>
                        <th>Opciones</th>
                      </tr>
                    </thead>
                    <tbody></tbody>
                  </table>
                </div>
              </div>
            </div>
          </Card.Content>
        </Card>
      </div>
      </Templates.Default.BasePageRoute2>
    );
  }
}
export default connect(getMapStateDefault(), {
    set_datapage,
    seDatatDocumentos,
    checkDataDirectorio,
  })(Cientificos);
  

